export const environment = {
  production: true,
  // url_django: 'https://api.sdgpss.net/',
  url_django: 'https://api.sdgpss-inweh.unu.edu/',
  component: {
    capacity: 1,
    policy: 2,
    extra: 3,
    finance: 4,
    resilience: 5,
    gender: 6,
    transparency: 7,
    status:8
  },
  testmode: false,
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts